import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ASolApp from './ASolApp';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<ASolApp />, document.getElementById('root'));
registerServiceWorker();
